<template>
    <div id="User" class="app-inner">
        <div class="p-tit-c">
             <div class="businessList-filter">
                <div class="businessList-filter-list flex align-cen">
                     <div class="fl-le flex align-cen">
                    <div class="label">用户ID：</div>
                    <div class="el-select1">
                        <el-input placeholder="请输入用户ID" v-model="search" clearable> </el-input>
                    </div>
                    </div>
                     <div class="fl-rt flex align-cen">
                    <div class="label">手机号：</div>
                    <div class="el-select1">
                        <el-input placeholder="请输入手机号" v-model="search1" clearable> </el-input>
                    </div>
                    </div>
                    <div class="fl-rt flex align-cen">
                    <div class="label">所属企业名称：</div>
                    <div class="el-select1">
                        <el-input placeholder="请输入所属企业名称" v-model="search2" clearable> </el-input>
                    </div>
                    </div>
                     <div class="fl-rt flex align-cen">
                    <div class="label">所属企业ID：</div>
                    <div class="el-select1">
                        <el-input placeholder="请输入所属企业ID" v-model="search3" clearable> </el-input>
                    </div>
                    </div>
                </div>
                 <div class="businessList-filter-list flex align-cen">
                    <div class="label">注册渠道：</div>
                     <el-select
                            v-model="value"
                            clearable
                            placeholder="请选择"
                            @change="dataSuccess"
                        >
                            <el-option
                            v-for="(item,index) in options"
                            :key="index"
                            :label="item"
                            :value="item"
                            >
                            </el-option>
                        </el-select>
                 </div>
                 <div class="businessList-filter-list flex align-cen">
                    <div class="label">账号状态：</div>
                      <div
                            style="color: red; padding-right: 20px; cursor: pointer"
                            @click="allradio"
                            >
                            不限
                            </div>
                        <el-radio v-model="radio" label="1" @change="dataSuccess">启用</el-radio>
                        <el-radio v-model="radio" label="0" @change="dataSuccess">禁用</el-radio>
                 </div>
                  <div class="businessList-filter-list flex align-cen">
                     <div class="label">最后登录：</div>
                      <el-date-picker
                            v-model="value1"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :picker-options="pickerOptions2"
                            @change="dataSuccess"
                            >
                            </el-date-picker>
                  </div>
                  <div class="businessList-filter-list flex align-cen">
                    <div class="label">注册时间：</div> 
                      <el-date-picker
                            v-model="value2"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :picker-options="pickerOptions2"
                            @change="dataSuccess"
                            >
                            </el-date-picker>
                  </div>
                   <div class="businessList-filter-list flex align-cen public-btn-small">
        <div class="public-btn-small-primary" @click="dataSuccess">
          搜索
        </div>
        <div class="public-btn-small-plan" @click="exportExcel(multipleSelection)">
          导出
        </div>
        <div class="public-btn-small-text" @click="reset">
          重置筛选条件
        </div>
      </div>
             </div>
        </div>

          <div class="businessList-container">
            <div class="businessList-container-table">
                    <el-table
          ref="multipleTable"
          :data="itemList"
          tooltip-effect="dark"
          style="width: 100%"
          border
          :row-key="getRowKeyOfTarget"
          @selection-change="handleSelectionChange"
          id='mytable'
          :header-cell-style="{background:'#f7f8fa',color:'#333'}"
        >
         <el-table-column type="selection" width="55" reserve-selection align="center" fixed="left"> </el-table-column>
          <el-table-column prop="id" label="用户id" align="center" width="150">
          </el-table-column>
           <el-table-column prop="userName" label="昵称" align="center" width="150">
          </el-table-column>
           <el-table-column prop="loginName" label="手机号" align="center" width="150">
          </el-table-column>
           <el-table-column  label="所属企业" align="center" width="200">
            <template slot-scope="scope">
               <el-button type="text" size="small"  slot="reference" style="color:red" @click.stop="openDialog(scope.row)">{{scope.row.businessNum}}条记录/查看记录</el-button>
            </template>
          </el-table-column>
           <el-table-column  label="最后登录" align="center" width="200">
            <template slot-scope="scope">
               {{scope.row.loginTime || '暂无数据'}}
            </template>
          </el-table-column>
           <el-table-column prop="loginNum" label="登录次数" align="center">
          </el-table-column>
           <el-table-column prop="createTime" label="注册时间" align="center" width="200">
          </el-table-column>
           <el-table-column prop="channel" label="注册渠道" align="center" width="200">
          </el-table-column>
           <el-table-column prop="score" label="用户积分" align="center" width="150">
          </el-table-column>
           <el-table-column label="账号启用状态" align="center" width="150">
           <template slot-scope="scope">
             <div class="buStatus" @click.stop="changeStatus(scope)">
                <el-switch
                  v-model="scope.row.state == 0 ? false : true"
                  disabled
                >
                </el-switch>
              </div>
           </template>
          </el-table-column>
            <el-table-column
            fixed="right"
            label="操作"
            align="center"
            width="150"
            
            >
            <template slot-scope="scope">
                <el-button type="text" size="small"  slot="reference" style="color:red" @click.stop="detail(scope.row)">查看详情</el-button>
            </template>
            </el-table-column>
        </el-table>
         <el-pagination
          class="jiange"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="pageSizes"
          :page-size="PageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
        >
        </el-pagination>
            </div>
          </div>
            <!-- 增加企业弹窗 -->
      <el-dialog
  title="所属企业"
  :visible.sync="centerDialogVisible"
  width="50%"
  :append-to-body="true"
  center>
            <el-table
            :data="buArr"
            border
            style="width: 100%"
            :header-cell-style="{background:'#f7f8fa',color:'#333'}"
            >
            <el-table-column
            prop="id"
            label="企业ID"
           align="center"
             >
            </el-table-column>
            <el-table-column
            prop="name"
            label="企业名称"
           align="center"
            >
            </el-table-column>
          <el-table-column label="是否为企业管理员" align="center">
            <template slot-scope="scope">
              <span>{{
                scope.row.isAdmin == 0
                  ? "否"
                  : "是"
              }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
    </div>
</template>
<script>
import exportExcel from '../../utils/exportExcel.js' //导出数据公共方法
import {getUserList,channelList,editAccount,businessAccountDetail} from "@/api/index/index"  //用户列表、用户注册渠道列表、状态修改、用户详情
export default {
    name:'User',
    data() {
        return {
            buArr:[],
             totalNum:0,
        currentPage: 1, //初始页
        PageSize: 10, //每页的数据
        totalCount: 0,
        pageSizes:[10,20,30,40,50,100],
            centerDialogVisible:false,
            search:'',
            search1:'',
            search2:'',
            search3:'',
            radio:'',
            value:'',
            value1:'',
            value2:'',
            options:[
            ],
            multipleSelection: [],
            itemList:[],
            pickerOptions1: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          }, {
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          }, {
            text: '一周前',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }]
        },
                 pickerOptions2: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        start_time:'',
        end_time:'',
        start_time1:'',
        end_time1:''
        }
    },
    activated(){
  this.gethisInfo()
},
    created() {
        this.getChannelList()
    },
    methods: {
        // 打开企业弹框窗口
        openDialog(data){
                  businessAccountDetail({
                id:data.id
              })
            .then(res => {
                this.buArr = res.data.platformBusinessList
            })
            .catch(err => {
            })
            this.centerDialogVisible = true
        },
         // 打开企业管理员详情
        detail(data){
            this.$router.push({
            name: "adminDetail",
            query:{
                id:data.id,
                type:2
            }
           })
        },
            // 状态切换
      changeStatus(e){
        let params = {
            id:e.row.id,
            state:e.row.state == 1 ? '0' : '1'
        }
          editAccount(params,'put')
                        .then(res => {
                           if(res.code == 0){
                            e.row.state == 1 ? this.$message.error('禁用成功') : this.$message.success('启用成功')
                           }else{
                            this.$message.error(res.msg)
                            
                           }
                           this.gethisInfo()
                        })
                        .catch(err => {
                        })
      },
        // 重置
        reset(){
         this.search = ""
          this.search1 = ""
          this.search2 = ""
          this.search3 = ""
           this.radio = "",
           this.value = ""
           this.value1 = ""
           this.start_time=""
           this.start_time1=""
           this.end_time=""
           this.end_time1=""
           this.value2 = "",
           this.currentPage = 1
         this.gethisInfo()
        },
        // 时间选择
        dataSuccess(){
               if(this.value1){
             this.start_time = this.value1[0]
            this.end_time = this.value1[1]
            }
            else{
                this.start_time=""
                this.end_time = ""
            }
            if(this.value2){
            this.start_time1 = this.value2[0]
            this.end_time1 = this.value2[1]
            }else{
                this.start_time1 = ""
                this.end_time1 = ""
            }
             this.currentPage = 1
             this.gethisInfo()
        },
        // 账号状态
        allradio(){
            this.currentPage = 1
            this.radio = ""
            this.gethisInfo()
        },
                   // 获取列表
        gethisInfo(){
            let params = {
                id:this.search,
                userName:'',
                businessId:this.search3,
                businessName:this.search2,
                loginName:this.search1,
                source:'',
                state:this.radio,
                channel:this.value,
                current: this.currentPage,
                size:this.PageSize,
                createTimeStart:this.start_time1,
                createTimeEnd:this.end_time1,
                loginTimeStart:this.start_time,
                loginTimeEnd:this.end_time
            }
            getUserList(params)
            .then(res => {
              this.itemList = res.data.records
             this.totalCount = res.data.total;
            })
            .catch(err => {
            })
        },
        // 渠道列表
        getChannelList(){
             channelList({})
            .then(res => {
                this.options = res.data
            })
            .catch(err => {
            })
        },
        //导出
          exportExcel(val){ 
             if(val.length !=0){
        let keyLisst = [] 
            for(let item in val){
             keyLisst.push( {
              '用户ID':val[item].id, 
              '昵称':val[item].userName, 
              '所属企业':val[item].businessNum + '家',
              '用户账号':val[item].loginName,
              '用户积分':val[item].score,
              '注册渠道':val[item].channel,
              '账号启用状态':val[item].state == 0 ? '禁用' : '开启',
              '关联微信号':val[item].wechatAccount || '暂无',
              '注册时间':val[item].createTime,
              '最后登录':val[item].loginTime || '暂无数据',
              '登录次数':val[item].loginNum
              } ) 
             }
         exportExcel.exportExcel(keyLisst,this.$route.meta.title)
             }else{
                this.$message.error('未选择导出数据')
             }
        },
         getRowKeyOfTarget(row) {
            return row.id
            },
            // 表格选择
         handleSelectionChange(val) {
        this.multipleSelection = val;
      },
       handleSizeChange(val) {
       this.PageSize = val
       this.gethisInfo()
    },
    handleCurrentChange(val) {
      this.currentPage = val
       this.gethisInfo()
    },
    },
}
</script>
<style lang="scss" scoped>
#User{
         .businessList-filter {
    padding-top: 10px;
    .businessList-filter-list {
      margin-top: 20px;
      .fl-rt {
        padding-left: 30px;
      }
    }
    .businessList-filter-list:first-child {
      margin-top: 0;
    }
  }
  .businessList-container {
    .businessList-container-title {
      font-size: 18px;
      color: #409eff;
      background-color: rgba(242, 242, 242, 1);
      padding: 10px 20px;
      .mft {
        cursor: pointer;
      }
    }
    .businessList-container-table {
      margin-top: 20px;
      .el-switch {
        position: relative;
        z-index: 1 !important;
      }
      .el-switch.is-disabled {
        opacity: 1 !important;
      }
      .buStatus{
        width: 50px;
        margin: 0 auto;
      }
    }
    .jiange {
      margin-top: 20px;
    }
  }
}
::v-deep {
  .el-switch.is-disabled .el-switch__core {
    cursor: pointer !important;
    width: 50px !important;
  }
}
</style>